// @flow

export function searchRemote(): string {
  return `
    remote {
      date
      placeholder
      searchAction
      title
    }
  `;
}

export function resortStartingPrice(): string {
  return `
    startingPrice {
      bookingButtonLabel
      allInclusive
      roomOnly
      departureDateLabel
      departureCityLabel
      durationUnit
      seeDetails
      dateFormat
    }
  `;
}

export function resort(appContext: AppContext): string {
  const { cmsContent = '', cmsRelease = '' } = appContext;
  const cmsArgs = `content : "${cmsContent}", release : "${cmsRelease}"`;
  return `
    resort {
      season(${cmsArgs}) {
        winter
        summer
        button
      }
      ${resortStartingPrice()}
      pricePopin {
        buttonLabel
        buttonTourLabel
        taxeAndFees
      }
      tripadvisor {
        menubar {
          reviews
        }
      }
      moreResultsLabels {
        label
        buttonLabel
      }
    }
  `;
}

export function price(): string {
  return `
    price {
      format{
        from
        instead
        flightIncluded
        viewRates
      }
    }
  `;
}

export function faceting(): string {
  return `
    common {
      dateFormatPlaceholder
      loadLess
      loadMore
      selectedCriteriasLabel {
        _1
        n
      }
    }
    booking {
      form {
        dateFormat
        dayPlaceholder
        monthPlaceholder
        yearPlaceholder
        departureDateTitle
        selectAdultsLabels {
          _1
          n
        }
        selectChildrenLabels {
          _1
          n
        }
      }
      editCriteria {
        validateCriteria
      }
    }
    faceting {
      intro
      facetClear
      oneResortThatMatchYourCriteria
      nbResortsThatMatchYourCriteria
      viewResorts
      searchTitle
      searchLinkLabel
      reset
      validate
      when {
        title
        subTitle
        durations
        duration
        from
        bestPrice
        lastAvailability
        notAvailable
        departureDateTitle
        arrivalDateTitle
        durationSingular
        durationPlural
        reinsurance
        pricesBasedOn
      }
      where {
        title
        destinationTitle
        countriesTitle
      }
      who {
        addChildcare
        adults
        ageComment
        ageSectionSubtitle
        birthdatePlaceholder
        kids
        kidsAgeLimit
        kidsBirthdate
        subTitle
        title
        withKidsFacetLabel
        withChildcareFacetLabel
      }
      activities {
        title
        sportTitle
        relaxTitle
        otherActivitiesTitle
      }
      compare {
        selectResort
        selected
        dateAndTransportMandatory
        unavailableThumbnail
        warningMessage
        title
        buttonLabel
        cancelLabel
        collapseLabel
        expandLabel
        dropzoneLabel
      }
      transport {
        selectPlaceholder
        titleFrom
        subTitle
        comment
        departingFrom
        defaultDepartureCityOnlyForDefaultTransportation
      }
      availabilities {
        childcare
        years
        year
        months
        available
        unavailable
        unknown
        urgentizationSingular
        urgentizationPlural
      }
      showFilterCTA
      hideFilterCTA
      typesOfStay {
        title
        label_village
        label_cruise
        label_tour
        label_villa
      }
      comfort {
        title
      }
    }`;
}

export function birthdatePopin() {
  return `birthdatePopin {
    title
    subtitle
    confirm
    child
    skip
  }`;
}

export function common() {
  return `common {
    close
    continue
    included
    allInclusive
  }`;
}

export function priceRemote() {
  return `${faceting()}
  ${common()}
  booking {
    form {
      selectAdultsLabels {
        _1
        n
      }
      selectChildrenLabels {
        _1
        n
      }
      selectDates
      selectParticipants
      selectTransports
      proposalsLoaderLabel
      errors {
        birthdayFormat
      }
    }
    priceCalendar {
      offers {
        bestPrice { label }
        urgentisation { label rateToDisplay }
      }
    }
  }
  price {
    format{
      from
      instead
      viewRates
      unitTotalPerTrip
    }
  }
  priceRemote {
    openAllInclusiveDetails
    closeAllInclusiveDetails
    notAvailable
    notAvailableCTA
    priceForAll
    priceRemoteButton
    linkToCalendar
  }
  resort {
    startingPrice {
      allInclusive
    }
  }
  `;
}
